import React from 'react';
import { APP_VERSION } from '../version';

// Small "update" window — shown once per device, after What's New (never at the same time).
// For a small update: change UPDATE_VERSION and the text. It resets NOTHING
// (the big What's New resets device settings; this one doesn't).
// the panel belongs to the FEATURE release (x.y.0): bug-fix versions (x.y.1, x.y.2…) don't show it again
export const UPDATE_VERSION = `${APP_VERSION.split('.').slice(0, 2).join('.')}.0`;
const KEY = 'updateNoteSeen';

// DEV ONLY: localhost/?update shows it again
export const isUpdatePreview = () => process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('update');

export const shouldShowUpdate = () => {
  if (isUpdatePreview()) return true;
  try { return localStorage.getItem(KEY) !== UPDATE_VERSION; } catch (e) { return false; }
};
const markSeen = () => { if (isUpdatePreview()) return; try { localStorage.setItem(KEY, UPDATE_VERSION); } catch (e) { /* private mode */ } };

export default function UpdateNote({ lang = 'en', onClose }) {
  const t = lang === 'fr' ? TR.fr : TR.en;
  const close = () => { markSeen(); onClose?.(); };
  return (
    <div className="wn-backdrop">
      <div className="wn-modal un-modal" role="dialog" aria-modal="true" aria-labelledby="un-title">
        <div className="wn-head">
          <span className="wn-kicker">{t.kicker} {UPDATE_VERSION}</span>
          <h2 id="un-title" className="wn-title">{t.title}</h2>
          <p className="wn-sub">{t.sub}</p>
        </div>
        <div className="wn-list">
          {t.items.map(([title, text]) => (
            <div key={title} className="wn-item">
              <b>{title}</b>
              <span>{text}</span>
            </div>
          ))}
        </div>
        {t.fixes?.length > 0 && (
          <div className="un-fixes">
            <span className="un-fixes-title">{t.fixesTitle}</span>
            <ul>{t.fixes.map((f) => <li key={f}>{f}</li>)}</ul>
          </div>
        )}
        <button type="button" className="wn-go" onClick={close}>{t.go}</button>
      </div>
    </div>
  );
}

// Each feature / major release: its new features + the bug fixes since the last release.
const TR = {
  en: {
    kicker: 'Update',
    title: 'New Predict the Night',
    sub: 'A whole new look, and a monthly jackpot panel.',
    items: [
      ['Predict the Night', 'New logo and a new swipe screen. Drag a team’s panel across and it takes over the whole screen.'],
      ['Jackpot panel', 'The monthly jackpot results now open in their own animated panel.'],
    ],
    go: 'Got it',
  },
  fr: {
    kicker: 'Mise à jour',
    title: 'Nouveau Prédis la soirée',
    sub: 'Un tout nouveau look, et un panneau pour le gros lot du mois.',
    items: [
      ['Prédis la soirée', 'Nouveau logo et nouvel écran de swipe. Glisse le panneau d’une équipe et il prend tout l’écran.'],
      ['Panneau du gros lot', 'Les résultats du gros lot du mois s’ouvrent maintenant dans leur propre panneau animé.'],
    ],
    go: 'Compris',
  },
};
